/**
 * <s-random-pick count="8">
 * Shows a random selection of its list items, in random order, on each visit.
 * Without JavaScript the first `count` items (rendered visible by Liquid) stay as they are.
 */
class SRandomPick extends HTMLElement {
  connectedCallback() {
    const list = this.querySelector('[data-random-pick-list]');
    if (!list) return;

    const items = Array.from(list.children);
    const count = Number.parseInt(this.getAttribute('count') || '8', 10);

    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    items.forEach((item, index) => {
      item.hidden = index >= count;
      list.appendChild(item);
    });
  }
}

if (!customElements.get('s-random-pick')) {
  customElements.define('s-random-pick', SRandomPick);
}
